'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _login = require('./login.component');

var _login2 = _interopRequireDefault(_login);

require('./login.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.login', [_angularUiRouter2.default]).component('login', _login2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('login', {
    parent: 'auth',
    url: '/login',
    component: 'login'
  });
}).name;


// WEBPACK FOOTER //
// ./components/auth/login/login.module.js